import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class Ga4Service {
  private userContext: Record<string, unknown> = {};

  constructor() {
    this.initDataLayer();
  }

  private initDataLayer(): void {
    // Inicializa o dataLayer se ele não existir
    if (typeof window !== 'undefined') {
      // Verifica se a propriedade dataLayer existe no objeto window
      if (!('dataLayer' in window)) {
        // Usa interface para definir a propriedade
        (window as any).dataLayer = [];
        console.log('GA4: dataLayer inicializado');
      }
    }
  }

  // High-level helper: envia eventos simples com params para o dataLayer
  emitWithParams(event: string, params: Record<string, unknown>): void {
    try {
      const merged = {
        ...this.userContext,
        ...params
      };
      this.initDataLayer();
      // @ts-expect-error - window.dataLayer é adicionado pelo Google Tag Manager e não reconhecido pelo TypeScript
      window.dataLayer.push({
        event,
        ...merged
      });
    } catch (error) {
      console.error(error);
    }
  }

  // Event helpers based on measurement plan
  trackSignUp(
    origem_cadastro: string,
    metodo = 'Web',
    page_platform = 'PremieRVet'
  ): void {
    this.emitWithParams('sign_up', {
      page_platform,
      origem_cadastro,
      metodo
    });
  }

  trackViewBlogContent(
    page_path: string,
    article_category: string,
    content_interest_score?: string
  ): void {
    const payload: Record<string, unknown> = {
      page_path,
      article_category
    };
    if (content_interest_score)
      payload.content_interest_score = content_interest_score;
    this.emitWithParams('view_blog_content', payload);
  }

  trackCrmInteraction(
    channel: string,
    campaign_id: string,
    destination_feature: string
  ): void {
    this.emitWithParams('crm_interaction', {
      channel,
      campaign_id,
      destination_feature
    });
  }

  trackLogin(login_origin: string, crm_source?: string): void {
    const payload: Record<string, unknown> = { login_origin };
    if (crm_source) payload.crm_source = crm_source;
    this.emitWithParams('login', payload);
  }

  trackUseTool(
    tool_name: string,
    tool_interaction_type: string,
    atribuicao_crm?: string
  ): void {
    const payload: Record<string, unknown> = {
      tool_name,
      tool_interaction_type
    };
    if (atribuicao_crm) payload.atribuicao_crm = atribuicao_crm;
    this.emitWithParams('use_tool', payload);
  }

  trackPrescriptionGenerated(
    orientacao_finalidade?: string,
    atribuicao_crm?: string
  ): void {
    const payload: Record<string, unknown> = {
      tool_name: 'Prescricao',
      tool_interaction_type: 'Generated'
    };
    if (orientacao_finalidade)
      payload.orientacao_finalidade = orientacao_finalidade;
    if (atribuicao_crm) payload.atribuicao_crm = atribuicao_crm;
    this.emitWithParams('use_tool', payload);
  }

  trackPrescricaoGerada(
    orientacao_finalidade: string,
    atribuicao_crm?: string
  ): void {
    const payload: Record<string, unknown> = {
      orientacao_finalidade
    };
    if (atribuicao_crm) payload.atribuicao_crm = atribuicao_crm;
    this.emitWithParams('prescricao_gerada', payload);
  }

  trackPushNotification(notification_title: string): void {
    this.emitWithParams('push_notification', {
      notification_title
    });
  }

  trackSignUpPet(raca: string, sexo: string, especie: string): void {
    this.emitWithParams('sign_up_pet', {
      raca,
      sexo,
      especie
    });
  }

  setUserContext(context: Record<string, unknown>): void {
    this.userContext = { ...this.userContext, ...context };
  }

  clearUserContext(): void {
    this.userContext = {};
  }

  emit(event: string, id?: string): void {
    try {
      console.log('ga4 emit:', event);
      this.initDataLayer();
      const payload: Record<string, unknown> = { event, ...this.userContext };
      // @ts-expect-error - window.dataLayer é adicionado pelo Google Tag Manager e não reconhecido pelo TypeScript
      window.dataLayer.push({
        ...payload,
        gtm: {
          _event: event,
          Event: event,
          Id: id
        }
      });
    } catch (error) {
      console.error(error);
    }
  }
}
